<app-ez-input cdkOverlayOrigin>
  <input appEzInput
    type="text"
    [formControl]="formControl"
    #input
    (input)="onInputSearch(input.value)"
    (focusin)="onOpenDropDown(input)"
    autocomplete="none"
    >

    <ng-template appEzRight>
      @if (isLoading) {
        <mat-spinner diameter="30" color="accent"></mat-spinner>
      }
      @if (!isLoading && input.value) {
        <button class="button-icon" (click)="onResetHints()">
          <i class="icomoon icomoon--close"></i>
        </button>
      }
    </ng-template>

    <ng-container ezLabel i18n="@@AddresHintLabel">City, street, house number</ng-container>
  </app-ez-input>

  <ng-template cdkPortal>
    <div class="select-dropdown">
      <div class="select-dropdown__inner">
        @if (!input.value || input.value.length < 4 || !hints) {
          <ng-content></ng-content>
        }

        @if (!isLoading && input.value.length >= 4) {
          @if (hints && hints.length) {
            <div class="select-list">
              @for (hint of hints; track hint.line1) {
                <div class="select-list__item">
                  <button class="select-list__button button button--th-help" (click)="onSelectAddress(hint)">
                    @if (hint.title && hint.subtitle) {
                      <div>{{ hint.title }}</div>
                      <div class="small">{{ hint.subtitle }}</div>
                    }
                    @if (!hint.title || !hint.subtitle) {
                      {{ hint.value }}
                    }
                  </button>
                </div>
              }
            </div>
          }
          @if (hints && hints.length === 0) {
            <div class="select-message message h3" i18n="@@SelectHintEmpty">
          No results were found for your request
        </div>
          }
        }
      </div>
    </div>
  </ng-template>
